import { Routes, Route } from 'react-router-dom';
import { LanguageProvider, useLanguage } from './contexts/LanguageContext';
import { SiteConfigProvider } from './contexts/SiteConfigContext';
import Layout from './components/layout/Layout';
import LanguagePopup from './components/LanguagePopup';
import Home from './pages/Home';
import About from './pages/About';
import Reviews from './pages/Reviews';
import Portfolio from './pages/Portfolio';
import Inquiry from './pages/Inquiry';
import Contact from './pages/Contact';
import ForBusiness from './pages/ForBusiness';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import ReturnRefund from './pages/ReturnRefund';
import Pickup from './pages/Shipping';
import Charity from './pages/Charity';
import Admin from './pages/Admin';
import './i18n/i18n';

const AppContent = () => {
  const { showLanguagePopup, setShowLanguagePopup, changeLanguage } = useLanguage();

  const handleLanguagePopupClose = () => {
    setShowLanguagePopup(false);
  };

  return (
    <>
      <Routes>
        <Route path="/" element={<Layout><Home /></Layout>} />
        <Route path="/about" element={<Layout><About /></Layout>} />
        <Route path="/reviews" element={<Layout><Reviews /></Layout>} />
        <Route path="/portfolio" element={<Layout><Portfolio /></Layout>} />
        <Route path="/inquiry" element={<Layout><Inquiry /></Layout>} />
        <Route path="/contact" element={<Layout><Contact /></Layout>} />
        <Route path="/for-business" element={<Layout><ForBusiness /></Layout>} />
        <Route path="/terms" element={<Layout><Terms /></Layout>} />
        <Route path="/privacy" element={<Layout><Privacy /></Layout>} />
        <Route path="/return-refund" element={<Layout><ReturnRefund /></Layout>} />
        <Route path="/pickup" element={<Layout><Pickup /></Layout>} />
        <Route path="/charity" element={<Layout><Charity /></Layout>} />
        <Route path="/admin" element={<Admin />} />
      </Routes>

      <LanguagePopup
        isOpen={showLanguagePopup}
        onClose={handleLanguagePopupClose}
        onLanguageSelect={changeLanguage}
      />
    </>
  );
};

function App() {
  return (
    <LanguageProvider>
      <SiteConfigProvider>
        <AppContent />
      </SiteConfigProvider>
    </LanguageProvider>
  );
}

export default App;